import React from "react";
import ReactDOM from "react-dom";
import CollectionSearchContainer from "./CollectionSearchContainer";

const rootElement = document.getElementById("collection-search");

const collectionUrl = document.body.getAttribute("data-base-url");
// process.env.NODE_ENV === 'production'
//   ? rootElement.getAttribute('data-base-url')
//   : process.env.SEARCH_COLLECTION_URL;

ReactDOM.createRoot(rootElement).render(
  <CollectionSearchContainer collectionUrl={collectionUrl} />
);
